import { render } from "./BlViewPlace.vue?vue&type=template&id=5d54c9de&scoped=true"
import script from "./BlViewPlace.vue?vue&type=script&lang=js"
export * from "./BlViewPlace.vue?vue&type=script&lang=js"

import "./BlViewPlace.vue?vue&type=style&index=0&id=5d54c9de&lang=scss&scoped=true"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d54c9de"]])

export default __exports__